interface Stat {
  value: string;
  label: string;
  prefix?: string;
  suffix?: string;
}

interface StatsProps {
  title?: string;
  stats?: Stat[];
  columns?: '2' | '3' | '4';
}

export function StatsBlock({ props }: { props: StatsProps }) {
  const stats = props.stats ?? [];
  if (stats.length === 0) return null;
  const cols = props.columns ?? '3';

  return (
    <section className="py-12 px-4">
      {props.title && <h2 className="text-2xl font-bold text-center mb-8">{props.title}</h2>}
      <div className={`grid gap-8 max-w-4xl mx-auto ${cols === '2' ? 'grid-cols-2' : cols === '4' ? 'grid-cols-2 sm:grid-cols-4' : 'grid-cols-2 sm:grid-cols-3'}`}>
        {stats.map((s, i) => (
          <div key={i} className="text-center">
            <div className="text-3xl font-bold text-zinc-900">
              {s.prefix}{s.value}{s.suffix}
            </div>
            <div className="text-sm text-zinc-500 mt-1">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
